__turbopack_context__.v({
  "active": "Teams-module-scss-module__s-fL7q__active",
  "bioMember": "Teams-module-scss-module__s-fL7q__bioMember",
  "bioMemberContent": "Teams-module-scss-module__s-fL7q__bioMemberContent",
  "bioMemberContentIn": "Teams-module-scss-module__s-fL7q__bioMemberContentIn",
  "bioMemberImage": "Teams-module-scss-module__s-fL7q__bioMemberImage",
  "bioMemberText": "Teams-module-scss-module__s-fL7q__bioMemberText",
  "blink": "Teams-module-scss-module__s-fL7q__blink",
  "clicked": "Teams-module-scss-module__s-fL7q__clicked",
  "description": "Teams-module-scss-module__s-fL7q__description",
  "email": "Teams-module-scss-module__s-fL7q__email",
  "gray": "Teams-module-scss-module__s-fL7q__gray",
  "inactive": "Teams-module-scss-module__s-fL7q__inactive",
  "nonBioMember": "Teams-module-scss-module__s-fL7q__nonBioMember",
  "plusMinus": "Teams-module-scss-module__s-fL7q__plusMinus",
  "teams": "Teams-module-scss-module__s-fL7q__teams",
  "title": "Teams-module-scss-module__s-fL7q__title",
  "titleMember": "Teams-module-scss-module__s-fL7q__titleMember",
});
